import { Box, Button, Card, Flex, Grid,
  GridItem, Heading, Text} from '@chakra-ui/react';
 import { BsPlusLg as PlusIcon } from "react-icons/bs";
 import { IoEyeOutline as EyeIcon } from "react-icons/io5";
 import { MdOutlineModeEditOutline as EditIcon} from "react-icons/md";
 import { TopLink} from '..';
 import { useState, useEffect } from 'react';
 import {openAtom,modalAtom, notificationAtom, openNAtom} from '../../../../context';
 import { useAtom } from 'jotai';
 import ViewSetting from '../Modal/ViewSetting';
 import apiCall from '../../../../utils/apiCall';
 import { useMutation, useQuery, useQueryClient } from 'react-query';
 import ReactPaginate from 'react-paginate';
 import styled from '@emotion/styled';
 import { Editor} from '../../../../components';
 import HTMLReactParser from 'html-react-parser';

 
 
 type ExamDataType ={
   Id:number;
   ExamInstructions:string;
 }
 
 
 const list: ExamDataType [] = [
   {
     Id:1,
     ExamInstructions:'Education Fee',
   },
   {
     Id:2,
     ExamInstructions:'Education Fee 2',
   },
   {
     Id:3,
     ExamInstructions:'Education Fee 3',
   },
   {
     Id:4,
     ExamInstructions:'Education Fee 4',
   }
 ]
 
 const ExamInstructionsEditor = () => {
   const [,set_open] = useAtom(openAtom);
   const [,set_modal] = useAtom(modalAtom);
   const [,set_open_notification] = useAtom(openNAtom);
   const [,set_notification] = useAtom(notificationAtom)
   const queryClient = useQueryClient();
 
   const {data:examList} = useQuery(['exam-instructions'],{
     queryFn:async()=>await apiCall().get(`/exam/setup/examInstruction`),
     select(data){
     return data.data.Data;
     }
   });
 
   const [filter_data,set_filter_data] = useState<any>(examList);
   const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  //console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
 
  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };
  useEffect(()=>{
    set_filter_data(examList)
  },[examList])
 
 
  //  const {mutate:deleteFee,isLoading:isloadingDelete} = useMutation({
  //    mutationKey:['delete-Fee-Type'],
  //    mutationFn:async(Id:number)=>{
  //      return await apiCall().get(`/exam/setup/examType/${Id}/delete`)
  //    },
  //    onSuccess:(data:any)=>{
  //      set_notification({
  //        type:'success',
  //        message:data?.data?.Message || 'Fee deleted successfully'
  //      });
  //      set_open_notification(true);
  //      queryClient.invalidateQueries({
  //        queryKey:['examType']
  //      })
  //    },
  //    onError(error:any){
  //      set_notification({
  //        type:'error',
  //        message:error?.data?.Message || 'Error Ocurred'
  //      });
  //      set_open_notification(true);
  //    },
  //    onSettled(){
  //      set_open(false);
  //    }
  //  })
  //  const handleDeleteFee = (Id:number) =>{
  //    set_modal({
  //      header:'Delete exam',
  //      content:<Flex  flexDir="column" gap="20px">
  //        <Text>
  //          Are you sure you want to delete this FeeSetup?
  //        </Text>
  //        <Flex p="10px 0" justify="space-between" align="center">
  //          <Button onClick={()=>set_open(false)} variant="outline" borderColor={'var(--dark-green-color'} 
  //            color="var(--dark-green-color)" >Cancel</Button>
  //          <Button onClick={()=>deleteFee(Id)} bg="var(--dark-green-color)" color="var(--white-color)">{isloadingDelete?'Loading':'Delete'}</Button>
  //        </Flex>
   
  //      </Flex>
  //    }
  //    )
  //    set_open(true);
  //  }
 
   const openAdd = (exam:ExamDataType | any) =>{
     set_modal({
       header: exam?.Id?'Update Exam Instructions':'Add Exam Instruction',
       content:exam?.Id?<AddType ExamInstructions={exam?.ExamInstructions} Id={exam.Id} />:<AddType />
     })
     set_open(true);
   }
 
   const openView = (exam:ExamDataType) =>{
       set_modal({
         header:'View Exam Instruction',
         content:<ViewType exam={exam} />
       })
       set_open(true);
   }
 
   return (
 
     <Box>
       <TopLink />
       <Flex justify="space-between" align="center" mt="20px">
         <Heading m="0" fontSize="1.5rem" color="var(--dark-green-color)">Exam Instructions Editor</Heading>
         <Button bg="var(--dark-green-color)" color="var(--white-color)"onClick={()=>openAdd(null)} leftIcon={<PlusIcon />}>Add Exam Instructions</Button>
       </Flex>
       <Flex mt="25px" flexDir="column" gap="10px">
             <Heading m="0" fontSize="1rem">All Exam Instructions</Heading>
             <Text m="0" fontSize=".8rem">showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
           </Flex>
       <Grid templateColumns={'repeat(1,.8fr)'} gap="20px" mt="20px">
 
        { examList && examList.length >0  ?examList.map(({Id,ExamInstructions}:any) => 
        <Card key={Id} as ={GridItem} p="20px" display="flex" gap="10px" justify="space-between" flexDir="row" >
             <Flex flexDir="column" gap="3px">
               <Box m="14">{HTMLReactParser(ExamInstructions)}</Box>
             </Flex>
             <Flex alignSelf="center" gap="10px" align="center" fontSize="1.2rem" >
               {/* <EyeIcon onClick={()=>openView({Id,ExamInstructions})}  style={{cursor:'pointer'}}/> */}
               <EditIcon onClick={()=>openAdd({Id,ExamInstructions})} style={{cursor:'pointer'}} />
             </Flex>
         </Card>):''}
       </Grid>
       <StylePaginateBox>
         <ReactPaginate
           breakLabel="..."
           nextLabel=">"
           onPageChange={handlePageClick}
           pageRangeDisplayed={5}
           pageCount={pageCount}
           previousLabel="<"
           renderOnZeroPageCount={null}
         />
 
       </StylePaginateBox>
       
     </Box>
   
     
   )
 }
 const StylePaginateBox = styled.div`
 width:100%;
 & > ul{
   list-style-type: none;
   text-align:center;
   padding:0;
   margin:0;
   margin-top:10px;
 } 
 & > ul > li{
   display: inline;
   margin:0 5px;
   padding:2px 5px;
   border-radius: 3px;
   background-color: transparent;
   color:var(--dark-green-color);
 }
 & > ul > li.selected{
   background-color: var(--highlight-paginate-background);
   color:var(--highlight-paginate-color);
 }
 & > ul > li:first-of-type,
 & > ul > li:last-of-type{
   font-weight: bold;
 }
 `
 
 export default ExamInstructionsEditor;
 
 const ViewType = (props:any) =>{
   const exam = props.exam;
   return (
     <ViewSetting >
       <Flex width="100%" justify="space-between" as={GridItem}>
         <span>ExamInstructions</span> {exam?.ExamInstructions}</Flex>
     </ViewSetting>
   )
 }
 
 const AddType = (props:any) =>{
   const queryClient = useQueryClient();
   const [,set_open] = useAtom(openAtom);
   const [,set_open_notification] = useAtom(openNAtom);
   const [,set_notification]= useAtom(notificationAtom);
   const [value,set_value] = useState<any>(props?.ExamInstructions ||'' );
   
   const {mutate:addUpdate,isLoading} = useMutation({
     mutationKey:['new-Exam-Instruction'],
     mutationFn:async (data:any)=> {
      console.log(props.Id);
       return props && props.Id?await apiCall().put(`/exam/setup/examInstruction/${props.Id}`,data):await apiCall().post(`/exam/setup/examInstruction`,data)},
     onSuccess:(data:any)=>{
       set_notification({
         type:'success',
         message:data.data.Message || 'Exam Instructions Added Successfully'
       });
       set_open_notification(true)
       queryClient.invalidateQueries({
         queryKey:['exam-instructions']
       })
     },
     onError(error:any){
       set_notification({
         type:'error',
         message:error.data.Message || 'Error Occured'
       });
       set_open_notification(true)
     },
     onSettled:()=>{
       set_open(false);
     }
   } )

   const handleSubmit = () =>{
      //console.log(value,'editor value');
      if(value && value.length > 0){
         addUpdate({ExamInstructions:value});
      }
      else{
        set_notification({
          type:'error',
          message:'Write Something inside Editor'
        })
        set_open_notification(true);
      }
   }
   return (
     <>
      <Flex flexDir="column" gap="10px">
        <Editor value={value} onChange={set_value} />
        <Flex>
          <Button onClick={handleSubmit} bg="var(--dark-green-color)"color="var(--white-color)">{isLoading?'Loading ...':'Submit'}</Button>
        </Flex>
      </Flex>
      
     </>
   )
 }
   